import React, { useEffect, useState } from 'react';
import PropType from 'prop-types';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import Button from 'components/Core/Button';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import { getColor } from 'utils/colorUtility';
import WistiaVideo from 'components/Core/WistiaVideo';
import ContentfulModalTool from 'components/Contentful/ContentfulTool/ModalTool';
import CallToActionTextLabel from './CallToActionTextLabel';

const ContentfulCallToAction = (props) => {
  const {
    buttonClass,
    buttonLabel,
    color,
    handleClick,
    handleClose,
    id,
    isPlaying,
    isCtaPopoverVideo,
    modalForm,
    setIsPlaying,
    setIsVideoPlaying,
    toggleIsVideoModalOpen,
    shadow,
    styles,
    textLabel,
    tool,
    tooltip,
    type,
    url,
    useModalForm,
    wistiaVideo,
    videoId,
    isWistiaCta,
    useCtaParentRouting,
    ...otherProps
  } = props;

  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const WISTIA = 'https://servicetitan-1.wistia.com';
  const popover = url?.includes(WISTIA);

  const handleOnClick = () => {
    if (handleClick) {
      handleClick();
    }

    if (toggleIsModalOpen && setIsPlaying) {
      toggleIsVideoModalOpen(true);
      setIsPlaying(!isPlaying);
    }

    if (setIsPlaying) {
      setIsPlaying(!isPlaying);
    } else if (useModalForm || tool) {
      toggleIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    if (typeof handleClose === 'function') {
      handleClose();
    }
    toggleIsModalOpen(false);
  };

  useEffect(() => {
    if (isWistiaCta) {
      document
        .querySelector(`.wistia-cta-button-${videoId}`)
        ?.addEventListener('click', handleOnClick);
    }
  });

  return (
    <>
      {popover ? (
        <WistiaVideo
          url={url}
          label={
            textLabel ? <ContentfulRichText richText={textLabel} /> : buttonLabel || 'Play Video'
          }
          labelProps={{
            theme: getColor(textLabel?.color),
            labelSize: textLabel?.paragraphSize,
          }}
        />
      ) : wistiaVideo ? (
        <WistiaVideo {...wistiaVideo} cta={props} isCtaPopoverVideo={isCtaPopoverVideo} />
      ) : textLabel ? (
        <CallToActionTextLabel
          styles={styles}
          tooltip={tooltip}
          url={url}
          handleOnClick={handleOnClick}
          textLabel={textLabel}
          {...otherProps}
        />
      ) : (
        <Button
          className={buttonClass}
          type={type || color}
          shadow={shadow}
          styles={styles}
          to={useModalForm ? null : url}
          onClick={handleOnClick}
          id={id}
          useCtaParentRouting={useCtaParentRouting}
          {...otherProps}
        >
          {buttonLabel}
        </Button>
      )}
      {tool && (
        <ContentfulModalTool
          closeModal={() => handleModalClose()}
          visible={isModalOpen}
          {...tool}
        />
      )}
      {useModalForm && (
        <ModalMarketingForm
          isModalOpen={isModalOpen}
          onModalCancel={() => handleModalClose()}
          inlineMarketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ContentfulCallToAction;

ContentfulCallToAction.defaultProp = {
  shadow: false,
};

ContentfulCallToAction.propType = {
  buttonClass: PropType.string,
  buttonlabel: PropType.string,
  color: PropType.string,
  url: PropType.string,
  carryUtmParameters: PropType.bool,
  useModalForm: PropType.bool,
  type: PropType.string,
  shadow: PropType.bool,
};
